import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-admin';
import SaveIcon from '@material-ui/icons/Save';
import {useTranslation} from 'react-i18next';

const DripCampaignSaveButton = ({label = null, save, saving}) => {
    const {t} = useTranslation();

    if (label === null) {
        label = t('Save');
    }

    return (
        <Button
            disabled={saving}
            label={label}
            onClick={() => save()}
            variant={'raised'}
            style={{marginRight: '8px'}}>
            <SaveIcon/>
        </Button>
    );
};

DripCampaignSaveButton.propTypes = {
    label: PropTypes.string,
    save: PropTypes.func.isRequired,
    saving: PropTypes.bool.isRequired
};

export default DripCampaignSaveButton;